/** Radius and shell geometry. The numeric mirror of `styles/tokens.css`. */
export const RADIUS = {
  xs: 8,
  sm: 10,
  md: 12,
  lg: 14,
  xl: 18,
  window: 20,
  /**
   * The sign-in hero panel. The one surface that is a picture rather than a
   * layout, so it carries its own, much rounder corner — the page behind it
   * is barely there, and the panel is the whole composition.
   */
  hero: 40,
  pill: 9999,
} as const

/** The 4px grid. Nothing uses a value that is not here. */
export const SPACE = {
  hair: 2,
  xs: 4,
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  '2xl': 24,
  '3xl': 32,
} as const

export const SHELL = {
  /**
   * The sidebar, expanded. Collapsed it is gone entirely — no icon rail,
   * the same rule Project Studio's sidebar runs on: a rail is a third thing
   * to design, a permanent tax on the window, and a second navigation
   * surface that says less than the column it replaced.
   */
  sidebarWidth: 232,
  /** Below this the sidebar floats over the page instead of taking a column. */
  compactBreakpoint: 900,
  /**
   * The strip over the page that carries the sidebar toggle. The sidebar's
   * brand band shares this one number, so the wordmark and the toggle sit
   * on a single line — the two facts at the top of the window stay level
   * with each other even if either height is ever retuned.
   */
  topStripHeight: 52,
  /** The widest a page column grows. */
  pageMeasure: 1120,
  detailPanelWidth: 440,
} as const
